import { formFieldString, WorkflowIntegrationResponse } from '@cassiopeia/integration';
import { requiredValue } from '@nestech/utils';
import { AdditionalMapping, CriticalIllness } from '@web/service';

export const additionalPBUCriticalMapping: AdditionalMapping<CriticalIllness> =
  <T extends CriticalIllness>() =>
  (api: WorkflowIntegrationResponse, baseModel: T): T => {
    const illnessTypeBaseStep = baseModel.illnessType;

    const { formFields } = requiredValue(api.steps?.['illnessType'], 'Illness type');

    illnessTypeBaseStep.formFields = {
      ...illnessTypeBaseStep.formFields,
      criticalIllnessCancerType: formFieldString('criticalIllnessCancerType', formFields),
      criticalIllnessHeartBrainType: formFieldString('criticalIllnessHeartBrainType', formFields),
      criticalIllnessOrgantransplantationType: formFieldString('criticalIllnessOrgantransplantationType', formFields),
      previousCriticalIllnessCancerType: formFieldString('previousCriticalIllnessCancerType', formFields),
      previousCriticalIllnessHeartBrainType: formFieldString('previousCriticalIllnessHeartBrainType', formFields),
      previousCriticalIllnessOrgantransplantationType: formFieldString(
        'previousCriticalIllnessOrgantransplantationType',
        formFields,
      ),
    };

    return baseModel;
  };
